import { render, staticRenderFns } from "./Bchart.vue?vue&type=template&id=3dad8a62"
import script from "./Bchart.vue?vue&type=script&lang=js"
export * from "./Bchart.vue?vue&type=script&lang=js"
import style0 from "./Bchart.vue?vue&type=style&index=0&id=3dad8a62&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports